import React from "react";
import { Box, Card, CardContent, CardMedia, Grid, Typography } from "@mui/material";
import PageHeader from "../PageHeader";

const cataloguePreviews = [
	{
		name: "Ignition coils and harnesses",
		previewImage:
			"https://argusweb.azureedge.net/argus-web/catalogues/catalogue-ignition-coils-and-harnesses-preview.jpg",
		link: "https://argusweb.azureedge.net/argus-web/catalogues/catalogue-ignition-coils-and-harnesses.pdf"
	},
	{
		name: "Fuel pumps",
		previewImage:
			"https://argusweb.azureedge.net/argus-web/catalogues/catalogue-fuel-pumps-preview.jpg",
		link: "https://argusweb.azureedge.net/argus-web/catalogues/catalogue-fuel-pumps.pdf"
	}
];

const Catalogues = () => {
	return (
		<Box sx={{ minHeight: "60vh" }}>
			<PageHeader title="Catalogues" />
			<Grid container spacing={3} justifyContent="center" sx={{ py: 4 }}>
				{cataloguePreviews.map((c, index) => (
					<Grid item xs={12} sm={6} md={4} key={index}>
						<Card
							component="a"
							href={c.link}
							target="_blank"
							rel="noopener noreferrer"
							sx={{
								display: "block",
								height: "100%",
								textDecoration: "none",
								borderRadius: "2px"
							}}
						>
							<CardMedia
								component="img"
								image={c.previewImage}
								alt={c.name}
								sx={{ objectFit: "contain", p: 2, maxHeight: 260 }}
							/>
							<CardContent>
								<Typography variant="body2" align="center">
									{c.name}
								</Typography>
							</CardContent>
						</Card>
					</Grid>
				))}
			</Grid>
		</Box>
	);
};
export default Catalogues;
